import React from 'react';
import { Toolbar, Stack, SxProps, Theme } from '@mui/material';
import { neutral } from '../../_foundations/phxColors';

export interface PageToolbarProps {
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const PageToolbar: React.FC<PageToolbarProps> = ({ leftItems, rightItems, sx }) => {
  return (
    <Toolbar
      className='lex-page-toolbar'
      sx={{
        border: '1px solid',
        borderColor: neutral[100],
        bgcolor: neutral[50],
        borderRadius: 3,
        p: 6,
        ...sx,
      }}
    >
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
        sx={{ flexGrow: 1 }}
      >
        {leftItems}
      </Stack>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
      >
        {rightItems}
      </Stack>
    </Toolbar>
  );
};

export default PageToolbar;
